import script from "./password.vue?vue&type=script&setup=true&lang=js"
export * from "./password.vue?vue&type=script&setup=true&lang=js"

import "./password.vue?vue&type=style&index=0&id=3de01edc&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de01edc"]])

export default __exports__